/**
 * @generated SignedSource<<a8ccb68798c743c9ff5239450fbeee8f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CaseStudyOffer_company$data = {
  readonly offers: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly " $fragmentSpreads": FragmentRefs<"useOfferName">;
      } | null;
    } | null>;
  };
  readonly " $fragmentType": "CaseStudyOffer_company";
};
export type CaseStudyOffer_company$key = {
  readonly " $data"?: CaseStudyOffer_company$data;
  readonly " $fragmentSpreads": FragmentRefs<"CaseStudyOffer_company">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CaseStudyOffer_company",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "isAccepted",
          "value": true
        }
      ],
      "concreteType": "OfferNodeConnection",
      "kind": "LinkedField",
      "name": "offers",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "OfferNodeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "OfferNode",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "useOfferName"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "offers(isAccepted:true)"
    }
  ],
  "type": "CompanyNode",
  "abstractKey": null
};

(node as any).hash = "46f9a42a0ec76f5b4be7b51359fdb41c";

export default node;
